import { ServiceMetaData } from "@/types/meta";

const getCodimeHomeMeta = (path = "/ko") => {
  const defaultMetaData = {
    imageUrl:
      "https://codime-ses-email-img.s3.ap-northeast-2.amazonaws.com/og-tag/codime_landing_main_240830.png",
    title: "포투 - 패션 모델 컷 생성 AI 솔루션",
    description: "클릭만으로 완성하는 우리 스토어만의 차별화된 콘텐츠",
    serviceUrl: "https://potoo.ai",
  };
  const defaultEnMetaData = {
    imageUrl:
      "https://codime-ses-email-img.s3.ap-northeast-2.amazonaws.com/og-tag/codime_landing_main_240830.png",
    title: "Potoo - AI Solution for Fashion Model Shots",
    description: "Easily create unique content for your store with just a click.",
    serviceUrl: "https://potoo.ai/en",
  };

  //OG TAG
  const metaDataMap: Record<string, ServiceMetaData> = {
    "/ko": defaultMetaData,
    "/ko/credit": {
      imageUrl:
        "https://codime-ses-email-img.s3.ap-northeast-2.amazonaws.com/og-tag/codime_landing_price_240830.png",
      title: "합리적인 가격으로 AI 모델 컷 생성",
      description: "모델 섭외와 스튜디오 촬영 비용보다 99% 저렴하게, 나만의 AI 모델 컷을 만들어 보세요.",
      serviceUrl: "https://potoo.ai/ko/plan",
    },
    "/ko/customer": {
      imageUrl:
        "https://codime-ses-email-img.s3.ap-northeast-2.amazonaws.com/og-tag/codime_landing_customer_241122.png",
      title: "포투를 통한 성장 경험, 고객의 목소리",
      description: "Potoo AI가 비즈니스에 어떤 변화를 가져올지 확인해 보세요!",
      serviceUrl: "https://potoo.ai/ko/customer",
    },
    "/en": defaultEnMetaData,
    "/en/credit":  {
      imageUrl:
        "https://codime-ses-email-img.s3.ap-northeast-2.amazonaws.com/og-tag/codime_landing_price_en_240313.png",
      title: "Generate AI Model Shots at an Affordable Price",
      description: "Create your own AI model images at 99% less cost than hiring models and studio shoots",
      serviceUrl: "https://potoo.ai/en/plan",
    },
    "/en/customer": {
      imageUrl:
        "https://codime-ses-email-img.s3.ap-northeast-2.amazonaws.com/og-tag/codime_landing_customer_en_241122.png",
      title: "Growth with Potoo AI: Customer Success Stories",
      description: "Discover how Potoo AI can transform your business!",
      serviceUrl: "https://potoo.ai/en/customer",
    },
  };
  return metaDataMap?.[path] || defaultMetaData;
};

export default getCodimeHomeMeta;
